import React from 'react';
import PropTypes from 'prop-types';
import { TABS } from '../../consts';
import { TabsWrapper, TabsContainer } from './styled';
import Tab from './tab';

const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <TabsWrapper>
      <TabsContainer>
        {TABS.map((item) => (
          <Tab
            item={item}
            key={item.name}
            isActive={activeTab === item.name}
            onClick={() => setActiveTab(item.name)}
          />
        ))}
      </TabsContainer>
    </TabsWrapper>
  );
};

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired
};

export default Tabs;
